import React, { useContext, createContext, useState } from "react";
import { boilerData } from "./data/boilerData";

const QuoteContext = createContext();

const QuoteProvider = ({ children }) => {
  const [postcode, setPostcode] = useState("");
  const [boilerType, setBoilerType] = useState("");
  const [fuelType, setFuelType] = useState("");
  const [numBedrooms, setNumBedrooms] = useState(null);
  const [fluePosition, setFluePosition] = useState("wall");
  const [reason, setReason] = useState("");
  const [boilerLocation, setBoilerLocation] = useState("");
  const [property, setProperty] = useState("");
  const [numBathrooms, setNumBathrooms] = useState(null);

  const fuelTypeClick = (type) => {
    setFuelType(type);
  };

  const boilerTypeClick = (type) => {
    setBoilerType(type);
  };

  const reasonClick = (type) => {
    setReason(type);
  };

  const boilerLocationClick = (type) => {
    setBoilerLocation(type);
  };

  const propertyClick = (type) => {
    setProperty(type);
  };

  const numBedsClick = (type) => {
    setNumBedrooms(type);
  };

  const numBathroomsClick = (type) => {
    setNumBathrooms(type);
  };

  const flueClick = (type) => {
    setFluePosition(type);
  };

  return (
    <QuoteContext.Provider
      value={{
        boilerData,
        postcode,
        setPostcode,
        boilerType,
        fuelType,
        numBedrooms,
        fluePosition,
        fuelTypeClick,
        boilerTypeClick,
        numBedsClick,
        reasonClick,
        reason,
        boilerLocationClick,
        boilerLocation,
        propertyClick,
        property,
        numBathroomsClick,
        numBathrooms,
        flueClick,
      }}
    >
      {children}
    </QuoteContext.Provider>
  );
};

export const useQuoteContext = () => {
  return useContext(QuoteContext);
};

export { QuoteContext, QuoteProvider };
